import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { css } from "styled-components";

twoButtonModalStyles.cancelButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
}